import React from 'react';
import { Link } from 'react-router-dom';
import './ChannelPartnerSection.css';
import partnerImage from '../assets/partner-visual.png';

const ChannelPartnerSection = () => {
  return (
    <div className="channel-partner-wrapper">
      <div className="partner-content">
        <div className="partner-image">
          <img src={partnerImage} alt="Channel Partner Visual" />
        </div>

        <div className="partner-form-block">
          <h2>
            Become a Channel Partner – Automotive Detailing and Car Protection Services
          </h2>

          <p>
            Join the Drive-In Car Spa network and tap into India’s growing demand for fast,
            reliable, and touchless car wash systems. As car paint protection and detailing specialists,
            we offer advanced solutions designed to deliver high-quality automotive detailing and car protection services while ensuring efficiency and scalability for your business. If you are looking for the{" "}
            <Link to="/" className="link-text">
              best car spa business partnership
            </Link>, this is your opportunity to build a future-ready automotive business.
          </p>

          <h3>JOIN US AS A CHANNEL PARTNER TODAY!</h3>
          <p className="highlight">STEP INTO SUCCESS — APPLY AS A PARTNER.</p>

          <form className="partner-form">
            <input type="text" placeholder="Your Name" />
            <input type="text" placeholder="Phone Number" />
            <input type="email" placeholder="Your email" />
            <input type="text" placeholder="Subject" />
            <textarea placeholder="Your message (optional)" rows="3"></textarea>
            <button type="submit">SUBMIT</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChannelPartnerSection;